import * as React from 'react'
import { Badge, badges } from 'DVWebNodeUI'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'
import { getStringIdSuffix, PluralizerSuffix } from '../../utils/pluralizer'

export interface ISeasonsBadgeProps {
  numOfSeasons?: number
  locale: string
}

interface StringIdsMap {
  [suffix: number]: StringId
}

const stringIds: StringIdsMap = {
  [PluralizerSuffix.one]: StringId.DV_DP_title_num_of_seasons_one,
  [PluralizerSuffix.few]: StringId.DV_DP_title_num_of_seasons_few,
  [PluralizerSuffix.many]: StringId.DV_DP_title_num_of_seasons_many,
  [PluralizerSuffix.other]: StringId.DV_DP_title_num_of_seasons_other,
}


export const Seasons = ({ numOfSeasons, locale }: ISeasonsBadgeProps) => {
  if (!numOfSeasons) {
    return null
  }

  const stringIdSuffix = getStringIdSuffix(numOfSeasons, locale)

  if (!stringIdSuffix) {


    return null
  }

  const string = stringIds[stringIdSuffix]

  return (
    <Badge use={badges.TEXT}>
      <TextLocalizer stringID={string} replace={{numOfSeasons: numOfSeasons.toString()}}/>
    </Badge>
  )
}
